import styled from "styled-components";

export const TableText = styled.span`
  font-size: 14px;
  color: #32A6D5;
`;